jQuery(function ($) {
    const $page = $('.trailers-catalog-page');
    if (!$page.length) return;

    const $form = $('#trailers-catalog-form');
    if (!$form.length) return;

    let isInitializing = true;
    let submitTimer = null;

    // Filters dropdown toggle (same UX as main catalog)
    function openFiltersSection() {
        const $btn = $page.find('.catalog-filters-dropdown .catalog-filters-dropdown-link').first();
        const $filtersSection = $page.find('.filters-section').first();
        if (!$btn.length || !$filtersSection.length) return;
        if ($filtersSection.is(':visible')) return;
        $filtersSection.stop(true, true).slideDown(0);
        $filtersSection.addClass('filters-open');
        $btn.addClass('opened-filters active');
        $btn.find('.close-hidden').addClass('d-block');
    }

    $(document).on("click", ".trailers-catalog-page .catalog-filters-dropdown .catalog-filters-dropdown-link", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $catalogPage = $(this).closest('.catalog-page');
        var $filtersSection = $catalogPage.find('.filters-section').first();
        var $closeHidden = $(this).find('.close-hidden');

        $filtersSection.stop(true, true).slideToggle(300, () => {
            const isVisible = $filtersSection.is(':visible');
            $filtersSection.toggleClass("filters-open", isVisible);
            $(this).toggleClass("opened-filters", isVisible);
            $(this).toggleClass("active", isVisible);
            $closeHidden.toggleClass("d-block", isVisible);
        });
    });

    // Keep filters visible after auto-submit reloads (GET params stay in URL)
    if (window.location.hash === '#open-filters' || (window.location.search || '').length > 1) {
        openFiltersSection();
    }

    function submitFilters(delayMs) {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(function () {
            $form.find('input[name="page"]').val('1');
            $form[0].submit();
        }, typeof delayMs === 'number' ? delayMs : 120);
    }

    if (typeof $.fn.selectize !== 'undefined') {
        $page.find('.trailers-filter-selectize').each(function () {
            const $select = $(this);
            if ($select.hasClass('selectized')) return;
            $select.selectize({
                plugins: ['clear_on_focus'],
                onChange: function () {
                    if (isInitializing) return;
                    submitFilters(80);
                }
            });
        });
    }

    $form.on('input', 'input[name="price_from"], input[name="price_to"], input[name="max_mass_from"], input[name="max_mass_to"]', function () {
        if (isInitializing) return;
        submitFilters(420);
    });

    $form.on('change', 'select', function () {
        if (isInitializing) return;
        submitFilters(80);
    });

    setTimeout(function () { isInitializing = false; }, 0);

    (function trackCatalogSearchFromUrl(contentCategory) {
        const params = new URLSearchParams(window.location.search || '');
        const ignored = ['page', 'sort'];
        const parts = [];
        params.forEach(function (value, key) {
            if (ignored.indexOf(key) !== -1 || String(value || '').trim() === '') {
                return;
            }
            parts.push(key + ':' + value);
        });
        if (!parts.length) {
            return;
        }
        if (window.CarBuyAnalytics && typeof window.CarBuyAnalytics.trackCatalogSearch === 'function') {
            window.CarBuyAnalytics.trackCatalogSearch({
                search_string: parts.join(' '),
                content_category: contentCategory,
                source: 'catalog_get_filters'
            });
        }
    })('trailers');
});


